import {IGetSourcesParams, IPictureSource, TBreakPointAbbreviation, TPictureSrcSet} from 'components/Picture/types';
import {adaptive} from 'styles/mixins/Adaptive';

/* eslint-disable sort-keys */

export const BREAKPOINT_TO_MEDIA: Partial<TPictureSrcSet> = {
    // 1921
    xxl: `(min-width: ${adaptive.SIZE_FULL_HD + 1}px)`,
    // 1024
    xl: `(min-width: ${adaptive.SIZE_LG_MIN}px)`,
    // 768
    lg: `(min-width: ${adaptive.SIZE_TABLET_SM_MIN}px)`,
    // 390
    sm: `(min-width: ${adaptive.SIZE_SM_MIN + 1}px)`,
    xs: '',
};

export const BREAKPOINT_TO_SORT_KEY: Record<TBreakPointAbbreviation, number> = {
    xs: 0,
    sm: 1,
    lg: 3,
    xl: 4,
    xxl: 5,
};

const getSource = ({breakpoint, src, mimeTypes, matcher}: IGetSourcesParams): IPictureSource => {
    return {
        media: matcher?.[breakpoint] || '',
        srcSet: src,
        type: mimeTypes?.[breakpoint] || undefined,
    };
};

export const getPictureSources = (
    set: Partial<TPictureSrcSet>,
    // eslint-disable-next-line @typescript-eslint/default-param-last
    breakpointMatcher = BREAKPOINT_TO_MEDIA,
    mimeTypes: IGetSourcesParams['mimeTypes'],
) =>
    Object.entries(set)
        .reduce(
            (acc, [breakpoint, src]) => {
                const sourceMatcher = breakpointMatcher
                    ? {...BREAKPOINT_TO_MEDIA, ...breakpointMatcher}
                    : BREAKPOINT_TO_MEDIA;
                const sourceBreakpoint = breakpoint as TBreakPointAbbreviation;
                const source = getSource({breakpoint: sourceBreakpoint, src, matcher: sourceMatcher, mimeTypes});

                const sortKey = BREAKPOINT_TO_SORT_KEY[breakpoint as TBreakPointAbbreviation];

                return [...acc, {source, sortKey}];
            },
            [] as {source: IPictureSource; sortKey: number}[],
        )
        .sort((a, b) => b.sortKey - a.sortKey)
        .map(({source}) => source);
